import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let token = {
    state: {
        path:"http://local.vrmaker.vip:8989/file/view?path=",
        token: "",
        isLogin: false,
    },
    mutations: {
        setToken: (state, token) => {
            state.isLogin = true
            state.token = token
        }
    },
    actions: {},
    getters: {},

}

export default new Vuex.Store({
    state: {},
    mutations: {
        clear: state => {
            state = {}
        }
    },
    actions: {},
    modules: {
        token,
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js